import colors from "../../base/colors";

const { light, secondary } = colors;
export default {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
      color: secondary.main,
    },
  },
};